import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ProfileTitleProps {
  title: string;
  star?: boolean;
  alignCenter?: string;
}
const ProfileTitle = ({
  title,
  star = false,
  alignCenter = 'start',
}: ProfileTitleProps) => {
  const { i18n } = useTranslation();
  const lines = title.split('\n');

  return (
    <Wrap data-en={i18n.language === 'en'} $alignCenter={alignCenter}>
      <Label>
        {lines.map((line, idx) => {
          const isLastLine = idx === lines.length - 1;

          return (
            <Line key={idx} $isBr={lines.length > 1}>
              {line}
              {isLastLine && star && <Star>*</Star>}
            </Line>
          );
        })}
      </Label>
    </Wrap>
  );
};

export default ProfileTitle;

interface WrapProps {
  $alignCenter: string;
}
const Wrap = styled.div<WrapProps>`
  display: flex;
  align-items: ${({ $alignCenter }) => $alignCenter};
  min-width: 147px;
  &[data-en='true'] {
    min-width: 170px;
  }
`;

const Label = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 20px;
  color: #6e98f8;
`;

const Line = styled.div<{ $isBr: boolean }>`
  line-height: ${({ $isBr }) => ($isBr ? '100%' : '120%')};
  position: relative;
`;

const Star = styled.span`
  font-size: 15px;
  line-height: 140%;
  color: #ff0000;
  position: relative;
  top: -5px;
  left: 2px;
`;
